import { Navigate, Outlet } from "react-router-dom";
import { useSessionProbe } from "@flame/shared/auth";
import { Spinner } from "@flame/shared/ui";

/**
 * Route guard: while the session probe loads, shows a full-page spinner.
 *
 * - no session                       → /login
 * - me.totp_required (enabled & !verified) → /totp/verify
 * - otherwise                         → render the nested outlet
 */
export function RequireAuth() {
  const { data: me, isLoading } = useSessionProbe();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!me) {
    return <Navigate to="/login" replace />;
  }

  if (me.totp_required) {
    return <Navigate to="/totp/verify" replace />;
  }

  return <Outlet />;
}
